import { Box } from '@mui/material';

import { PROVIDER_INDICATOR_STYLES } from '../styles/universal-location-map.styles';

export interface MapProviderIndicatorProps {
  providerText: string;
}

export function MapProviderIndicator({ providerText }: MapProviderIndicatorProps) {
  return <Box sx={PROVIDER_INDICATOR_STYLES}>{providerText}</Box>;
}
